import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="border-b border-line bg-panel py-8 sm:py-10" data-id="element-65" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto flex max-w-[1080px] flex-col items-start gap-4 px-4 sm:flex-row sm:items-center sm:px-6" data-id="element-66" data-mp="1o5zsi6gq6j6q">
        <ShieldCheckIcon className="h-12 w-12 shrink-0 text-mod-green sm:h-16 sm:w-16" strokeWidth={1.8} data-id="element-67" data-mp="1x4l7xsqwhi3a" />
        <div data-id="element-68" data-mp="19fsgo9l83yf0">
          <h2 className="text-[21px] font-bold leading-none text-white sm:text-[30px]" data-id="element-69" data-mp="19fad0rw8ehx2">
            Your purchase is <span className="text-mod-green" data-id="element-70" data-mp="14hhb4b1yoa2l">100% protected</span>
          </h2>
          <p className="mt-2 text-[13.5px] font-medium leading-snug text-metal sm:text-[16px]" data-id="element-71" data-mp="1j5c4zurpgkh9">
            Explore MOTORCYCLE DIAGNOSTIC PRO™ for 7 days. Access the complete
            6-module diagnostic system and all 5 professional bonuses. If it isn't
            right for you, contact us within 7 days for a full refund according to
            the refund terms.
          </p>
        </div>
      </div>
    </section>;
}